import React from 'react'
import { HomeComponent } from '../../components'

const Home = () => {
  return (
    <div>
      <HomeComponent />
    </div>
  )
}

export default Home
